import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SIC  {
    _originalTypeClassName = "zERP.BO.SIC";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SIC.translate = translateService;
}
this.Id = null;
this.Code = null;
this.Name = null;
this.SystemOwner = null;
this.FullName = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
SystemOwner:any;
FullName:any;
Description:any;

static GetFullName($this: any): any{return $this?.Code + " - " + $this?.Name;
}
static ParseOSYKDate(date: any): any{let year = date?.substr(0, 4);
let month = CLMS.Framework.String.Empty;
if (Joove.Common.stringContains(date, "-")) {month = date?.substr(5, 2);}else {month = date?.substr(4, 2);}
return moment([CLMS.Framework.Integer.Parse(year), (CLMS.Framework.Integer.Parse(month)) - 1, 1, 12, 0, 0]).toDate();
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}